import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { NavLink, useSearchParams } from "react-router-dom";
import PageHeading from "@/v2/components/ui/heading/Page";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";
import FindAllClient from "@/v2/api/client/FindAll";
import {
    ClientsColumn,
    ClientsFilterColumn,
} from "@/v2/components/data-table/columns/Client";
import { Client } from "@/v2/types";
import ExportClients from "@/v2/api/client/Export";
import AccessControl from "@/v2/components/rbac/AccessControl";

export default function ClientPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["clients", skip, limit, search, filter],
        queryFn: () =>
            FindAllClient({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Client Database"
                    description="Manage and monitor all clients in your platform"
                />

                <AccessControl
                    module="CLIENT_MANAGEMENT"
                    requestedAccess={"POST"}
                >
                    <div className="flex gap-4">
                        <NavLink to={"create"}>
                            <Button>Add New Client</Button>
                        </NavLink>
                    </div>
                </AccessControl>
            </div>

            <Card className="p-2">
                <TableToolbar<Client>
                    column={ClientsFilterColumn}
                    searchPlaceHolder="Search client.."
                    exportFileName="clients"
                    exportFunc={() => ExportClients({ filter })}
                />

                <DataTable<Client>
                    data={query.data?.data || []}
                    columns={ClientsColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
